<template>
    <div class="states">
        <div class="leading">
            <button class="btn btn-primary" id="show-modal" @click="editState()">Add State</button>
        </div>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead class="manager-list-heading">
                    <tr>
                        <th>State</th>
                        <th>Comm. Tax Rate</th>
                        <th>Res. Tax Rate</th>
                        <th class="actions">Actions</th>
                    </tr>
                </thead>
                <state-collection v-slot="{ states }">
                    <tbody class="manager-list-row">
                        <tr v-for="state in states" :key="state.id">
                            <td class="name" v-text="state.name"></td>
                            <td class="name" v-text="state.commercial_tax_rate"></td>
                            <td class="name" v-text="state.residential_tax_rate"></td>
                            <td class="actions">
                                <button class="btn btn-primary btn-sm" @click="editState(state.id)">Edit</button>
                            </td>
                        </tr>
                    </tbody>
                </state-collection>
            </table>
        </div>
        <state-modal v-if="showModal" @close="showModal = false;" :id="modalState"></state-modal>
    </div>
</template>
<script>
import Filterinrg from './helpers/Filtering';
import StateModal from './StateModal';
import ModalWatcher from './ModalWatcher';
import { ContinuousCollectionComponent } from 'clockvine-vue';

export default {
    components: {
        StateModal,
        stateCollection: ContinuousCollectionComponent.for("states")
    },

    mixins: [
        ModalWatcher
    ],

    data: () => ({
        showModal: false,
        modalState: null,
    }),

    methods: {
        editState(id) {
            this.modalState = id;
            this.showModal = true;
        },

        destroyState(id) {
            this.modalState = id;
        },
    },
}
</script>
